export default {
  // layout
  LAYOUT: {
    header: {
      ___webTitle: 'Web Title',
      ___functionMenu: 'Function Menu',
      ___userMenu: 'User Menu',
      functionMenu: {
        ___main: 'Main',
        ___mainIndex: 'MainIndex',
        ___index: 'Index',
        ___table: 'Table',
        ___grab: 'Grab',
        ___borCor: 'BorCor',
        ___treeMenu: 'Tree Menu',
        ___countup: 'Countup',
        ___util: 'Util'
      },
      userMenu: {
        ___login: 'Login',
        ___logout: 'Logout'
      }
    },
    footer: {
      ___title: 'Footer'
    },
    uploading: {
      ___default: 'Uploading'
    },
    dialog: {
      login: {
        ___title: 'User Login',
        form: {
          placeholder: {
            ___account: 'account',
            ___password: 'password',
            ___role: 'select role'
          },
          option: {
            role: {
              ___user: 'user',
              ___admin: 'admin'
            }
          }
        }
      }
    }
  },
  // page
  PAGE: {
    main: {
      ___title: 'Main Field'
    },
    index: {
      ___list: 'list{count}'
    },
    mainIndex: {
      ___top: 'top',
      ___bottom: 'bottom'
    },
    table: {
      thead: {
        ___index: '#',
        ___name: 'Name',
        ___age: 'Age',
        ___date: 'Date',
        ___noteA: 'NoteA',
        ___noteB: 'NoteB'
      }
    },
    util: {
      ___content: 'Content'
    }
  },
  // component
  COMPONENT: {
  },
  // common
  COMMON: {
    button: {
      ___cancel: 'Cancel',
      ___login: 'Login',
      ___reset: 'Reset',
      ___select: 'Select',
      ___send: 'Send',
      ___add: 'Add',
      ___line: 'Line',
      ___grab: 'Grab',
      ___single: 'Single',
      ___multiple: 'Multiple',
      ___autoHeight: 'Auto Height'
    },
    toast: {
      ___noPermission: '權限不足',
      ___pleaseLogin: '請先登入',
      ___pageNotFound: '頁面不存在，或是權限不足'
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/lang/en/lang.js